module.exports = __webpack_public_path__ + "img/logo-not-log-in.39ecbec0.png";